<template>
  <NuxtLayout name="markup" background-class="bg-surface-tertiary">
    <MarkupGenerator :page-data="markupData" :is-page="true" />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { general_setPageTheme } from '~/utils/general/pageThemeClassFromMarkup';
import { ASYNC_KEY_ACCESSORIES_LISTING } from '~/models/AsyncDataKeys.model';

const config = useRuntimeConfig();
const route = useRoute();
const { $api } = useNuxtApp();
const notifications = useNotificationStore();
notifications.reset();

definePageMeta({
  layout: false,
});

const { data: markupData, error } = await useAsyncData(
  ASYNC_KEY_ACCESSORIES_LISTING,
  async () => {
    return await $api.categoryModule.getCategory(7);
  },
  {
    transform: cache_addFetchedAtTransform,
    getCachedData: cache_getCachedDataFromServer,
  },
);

const hasError = error.value || !markupData.value?.PageContent;

if (hasError) {
  notifications.setStandardErrorNotification();
}

filters_initializeFiltersIfListComponentExists(markupData.value, false);
general_setPageTheme(markupData.value?.PageContent);

const canonicalUrl = `${config.public.apiBaseUrl.replace(/\/$/, '')}${route.fullPath.split('?')[0]}`;

const seoInput = {
  seoData: {
    title: markupData?.value?.MetaTitle,
    description: markupData?.value?.MetaDescription,
    siteName: 'Halebop',
    keywords: markupData?.value?.MetaKeywords,
    canonicalUrl,
  },
  fallBackSeoData: {
    title: 'Mobiltillbehör | Halebop.se',
    description:
      'Fixa Halebop idag, då får du fria SMS till hela världen och massor med surf.  Vi har de senaste Mobiltelefonerna från Apple, Samsung, Nokia, Sony och många fler',
    siteName: 'Halebop',
    keywords: '',
    canonicalUrl,
  },
};
useCustomSeoMeta(seoInput);
</script>
<style scoped lang="scss"></style>
